// @ts-strict-ignore
import {Component, inject, Input, output} from "@angular/core";
import {NonSimulationSession, SessionType, TrainingRoom} from "@models";
import {zoomInOnEnterAnimation} from "angular-animations";
import {Translations} from "@translations";
import {SimMaterialDialogService} from "@services";
import {AsyncPipe, DatePipe} from "@angular/common";
import {MatDivider} from "@angular/material/divider";
import {MatIcon} from "@angular/material/icon";
import {MatIconButton} from "@angular/material/button";
import {TranslateModule, TranslateService} from "@ngx-translate/core";
import {GetTrainingRoomByIdPipe} from "@common/pipes/get-training-room-by-id.pipe";
import {StopPropagationDirective} from "@common/pipes/stop-propagation.directive";

@Component({
	selector: "sim-non-simulation-session-card",
	templateUrl: "./non-simulation-session-card.component.html",
	styleUrls: ["./non-simulation-session-card.component.scss", "../../session-card.component.scss"],
	animations: [zoomInOnEnterAnimation({duration: 175})],
	standalone: true,
	imports: [DatePipe, GetTrainingRoomByIdPipe, AsyncPipe, MatDivider, MatIcon, StopPropagationDirective, MatIconButton, TranslateModule],
})
export class NonSimulationSessionCardComponent {
	readonly translate = inject(TranslateService);
	@Input({required: true})
	public session: NonSimulationSession;

	@Input() showRemoveAction: boolean = false;
	@Input() showEditAction: boolean = false;

	@Input()
	public usedWithinEventSelection: boolean = false;

	edit = output<void>();
	delete = output<void>();

	protected readonly SessionType = SessionType;
	protected readonly T = Translations;

	constructor(private _simMaterialDialogService: SimMaterialDialogService) {}

	showDetailRoom(trainingRoom: TrainingRoom) {
		this._simMaterialDialogService
			.openShowRoomDetailDialog(
				{
					trainingRoom: trainingRoom,
				},
				{
					disableClose: false,
					width: "1200px",
				},
			)
			.then();
	}
}
